import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export const useFocusOnPageChange = () => {
  const location = useLocation();
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  useEffect(() => {
    if (isInitialLoad) {
      setIsInitialLoad(false);
      return;
    }

    const { activeElement } = document;

    if (activeElement instanceof HTMLElement && !activeElement.closest('[role="tablist"] [role="tab"]')) {
      activeElement.blur();
    }
  }, [location.pathname]); // React to changes in the path
};
